export const singleProfileItemStyles = `
  .qdc-card {
    position: relative;
    overflow: hidden;
    cursor: pointer;
    width: 100%;
    font-family: var(--font-sans);
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: var(--space-2);
    padding: var(--space-6) var(--space-4) var(--space-5);
    border-radius: var(--rad-catchup-xlarge);
    background: rgba(255, 255, 255, 0.2);
    -webkit-backdrop-filter: blur(28px) saturate(1.8);
    backdrop-filter: blur(28px) saturate(1.8);
    border: 1px solid rgba(255, 255, 255, 0.55);
    box-shadow: inset 0 1px 1px rgba(255, 255, 255, 0.7),
      0 18px 40px -20px rgba(15, 72, 89, 0.4);
    transition: transform var(--duration-base) var(--ease-glass),
      box-shadow var(--duration-base) var(--ease-glass);
  }
  .qdc-sheen {
    position: absolute;
    inset: 0 0 auto 0;
    height: 46%;
    background: var(--sheen-soft);
    pointer-events: none;
  }
  .qdc-card:hover {
    transform: translateY(-6px);
    box-shadow: inset 0 1px 1px rgba(255, 255, 255, 0.8),
      0 26px 50px -20px rgba(15, 72, 89, 0.5);
  }
  .qdc-card:active {
    transform: translateY(-2px) scale(0.99);
  }
  .qdc-card:focus-visible {
    outline: none;
    box-shadow: inset 0 1px 1px rgba(255, 255, 255, 0.8),
      0 0 0 3px var(--catchup-blue),
      0 18px 40px -20px rgba(15, 72, 89, 0.4);
  }
  .qdc-card.qdc-deleted {
    cursor: not-allowed;
    opacity: 0.6;
  }
  .qdc-card.qdc-deleted:hover {
    transform: none;
    box-shadow: inset 0 1px 1px rgba(255, 255, 255, 0.7),
      0 18px 40px -20px rgba(15, 72, 89, 0.4);
  }

  .qdc-ring {
    position: relative;
    width: 104px;
    height: 104px;
    border-radius: var(--rad-catchup-full);
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: var(--space-2);
    overflow: hidden;
    background: radial-gradient(circle at 50% 35%, #eaf9fc, #cbeef4);
    box-shadow: inset 0 1px 1px rgba(255, 255, 255, 0.9);
  }
  .qdc-ring::after {
    content: "";
    position: absolute;
    inset: -4px;
    border-radius: var(--rad-catchup-full);
    border: 3px solid;
  }
  .qdc-ring--teal::after {
    border-color: var(--catchup-blue);
  }
  .qdc-ring--coral::after {
    border-color: var(--accent-coral);
  }
  .qdc-ring--purple::after {
    border-color: var(--accent-purple);
  }
  .qdc-avatar {
    width: 84px;
    height: 84px;
    object-fit: contain;
  }

  .qdc-name {
    font-size: var(--fs-2xl);
    font-weight: 700;
    color: var(--text-primary);
    text-align: center;
  }
  .qdc-org {
    font-size: var(--fs-base);
    font-weight: 600;
    color: var(--text-secondary);
    text-align: center;
  }
  .qdc-chip {
    font-size: var(--fs-md);
    font-weight: 700;
    padding: 3px var(--space-3);
    border-radius: var(--rad-catchup-full);
    white-space: nowrap;
  }
  .qdc-chip--teal {
    color: var(--brand-dark);
    background: var(--brand-50);
  }
  .qdc-chip--coral {
    color: var(--accent-coral-text);
    background: var(--accent-coral-bg);
  }
  .qdc-chip--purple {
    color: var(--accent-purple-text);
    background: var(--accent-purple-bg);
  }

  .qdc-go {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    margin-top: var(--space-3);
    font-size: var(--fs-base);
    font-weight: 700;
    color: var(--brand-dark);
    padding: 8px var(--space-4);
    border-radius: var(--rad-catchup-full);
    background: rgba(255, 255, 255, 0.4);
    border: 1px solid rgba(255, 255, 255, 0.7);
    box-shadow: inset 0 1px 1px rgba(255, 255, 255, 0.8);
    opacity: 0;
    transform: translateY(6px);
    transition: opacity var(--duration-base) var(--ease-glass),
      transform var(--duration-base) var(--ease-glass);
  }
  .qdc-card:hover .qdc-go {
    opacity: 1;
    transform: translateY(0);
  }
  .qdc-deleted-text {
    color: var(--catchup-red);
  }

  .qdc-loader {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: var(--space-3);
    min-height: 44px;
  }

  @media (max-width: 720px) {
    .qdc-go {
      opacity: 1;
      transform: none;
    }
  }
`;
